export default "__VITE_ASSET__BPf1K2Dl__"